/** Visual tokens for knowledge-base file kinds (pdf, text). */
const FILE_TYPE_VISUALS = {
  pdf: {
    icon: 'mdi-file-pdf-box',
    color: '#ef4444',
    bg: 'rgba(239, 68, 68, 0.14)',
    label: 'PDF',
  },
  text: {
    icon: 'mdi-file-document-outline',
    color: '#3b82f6',
    bg: 'rgba(59, 130, 246, 0.14)',
    label: 'Text',
  },
}

const DEFAULT_VISUAL = {
  icon: 'mdi-file-outline',
  color: '#94a3b8',
  bg: 'rgba(148, 163, 184, 0.14)',
  label: 'File',
}

export function getKnowledgeBaseFileKindFromName(name) {
  const lower = String(name || '').toLowerCase()
  if (lower.endsWith('.pdf')) return 'pdf'
  if (lower.endsWith('.txt')) return 'text'
  return null
}

export function getKnowledgeBaseFileVisual(kind) {
  return FILE_TYPE_VISUALS[kind] || DEFAULT_VISUAL
}

export function knowledgeBaseFileIconStyle(kind) {
  const visual = getKnowledgeBaseFileVisual(kind)
  return {
    color: visual.color,
    backgroundColor: visual.bg,
  }
}
